module.exports = __webpack_public_path__ + "img/pointer.6ebaa3d8.png";